// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyByIdRequestModel from '../../model/get-company-by-id-request-model';
import GetCompanyByIdRequestDTO from '../dto/get-company-by-id-request-dto';
import dtoSchema from '../schemas/get-company-by-id-request-schema';

export default abstract class GetCompanyByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<GetCompanyByIdRequestDTO>): GetCompanyByIdRequestModel;
  static toModel(dto: DeepPartial<GetCompanyByIdRequestDTO> | undefined | null): GetCompanyByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyByIdRequestDTO> | undefined | null): GetCompanyByIdRequestModel | undefined {
    return dto ? new GetCompanyByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyByIdRequestModel> | GetCompanyByIdRequestModel): GetCompanyByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      eventIdentifier: unwrapped.eventIdentifier,
    } as GetCompanyByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyByIdRequestModel, can not map to GetCompanyByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
